import { render, staticRenderFns } from "./StepCovidFluLetter.vue?vue&type=template&id=90533502&"
import script from "./StepCovidFluLetter.vue?vue&type=script&lang=js&"
export * from "./StepCovidFluLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports